import { makeStyles } from '@material-ui/core';
import { graphql, useStaticQuery } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import React from 'react';
import CodeBlockToolbar from './toolbar';

type CodeBlockProps = {
  name: string;
};

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: theme.spacing(0.5),
    background: theme.palette.secondary.main,
  },
  contents: {
    overflowX: 'auto',
  },
}));

const CodeBlock: React.FC<CodeBlockProps> = ({ name }) => {
  const classes = useStyles();
  const data = useStaticQuery(graphql`
    query CodeBlockQuery {
      allMdx(filter: { fileAbsolutePath: { glob: "**/code-blocks/**/*" } }) {
        nodes {
          fileAbsolutePath
          body
        }
      }
    }
  `);

  const node = data.allMdx.nodes.find(n => n.fileAbsolutePath.includes(name));
  if (!node) {
    throw new Error(`Invalid code block: ${name}`);
  }

  return (
    <div className={classes.root}>
      <CodeBlockToolbar />
      <div className={classes.contents}>
        <MDXRenderer>{node.body}</MDXRenderer>
      </div>
    </div>
  );
};

export default CodeBlock;
